import { getPublicRouteUrl } from '@nackle/service-urls';

export const brandingURL = getPublicRouteUrl( 'BRANDING_SERVICE' );
export const kameURL = getPublicRouteUrl( 'KAME_API' );
export const serviceAwardsURL = getPublicRouteUrl( 'SERVICE_AWARDS' );
export const solutionURL = getPublicRouteUrl( 'SOLUTION_API' );
export const imageURL = getPublicRouteUrl( 'IMAGES' );
export const cmxURL = getPublicRouteUrl( 'CMX_SERVICE_V2' );
export const experienceURL = getPublicRouteUrl( 'EXPERIENCE_REGISTRY_API' );